/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagGroup } from '../../models/tag-group';

export interface CreateTagGroup$Params {
      body?: TagGroup
}

export function createTagGroup(http: HttpClient, rootUrl: string, params?: CreateTagGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<TagGroup>> {
  const rb = new RequestBuilder(rootUrl, createTagGroup.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TagGroup>;
    })
  );
}

createTagGroup.PATH = '/admin/tag-groups';
